import { createI18n } from 'vue-i18n'
import cs from './cs'
import de from './de'
import en from './en'
import hr from './hr'
import hu from './hu'
import pl from './pl'
import sk from './sk'

export type Locale = 'cs' | 'de' | 'en' | 'hr' | 'hu' | 'pl' | 'sk'

export const SUPPORTED_LOCALES: readonly Locale[] = ['cs', 'sk', 'en', 'de', 'pl', 'hu', 'hr'] as const

export const i18n = createI18n({
    legacy: false,
    locale: 'cs',
    fallbackLocale: 'en',
    messages: { cs, de, en, hr, hu, pl, sk },
    warnHtmlMessage: false
})

export function setLocale(locale: Locale) {
    i18n.global.locale.value = locale
}
